import React, { Component } from "react";
import { connect } from 'react-redux'
import { Row, Col, Table, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { T } from 'components/components/i18n'
import styles from './styles.less'
import { isMobile } from 'helpers/general'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

class CarInfo extends Component {
  render() {
    const {
      vehicle,
      standard,
      frontRim,
      rearRim,
      etFront,
      etRear
    } = this.props
    const front = (standard && standard.front) || {}
    const rear = (standard && standard.rear) || {}
    const frontTyre = (standard && standard.front && standard.front.tyre) || {}
    const rearTyre = (standard && standard.rear && standard.rear.tyre) || {}

    return (
      <div className={styles['carInfo']}>
        <Row className={styles.filters}>
          <Col xs={6}>
            <Table striped className={styles.carInfoTable}>
              <tbody>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Dimension"/> <T id="Front"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{frontTyre.dimension || '-'}</strong>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Dimension"/> <T id="Rear"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{rearTyre.dimension || '-'}</strong>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Speed index"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <span className={styles.front}><T id="Front"/> <strong>{frontTyre.speedIndex || '-'}</strong></span>
                    <span><T id="Rear"/> <strong>{rearTyre.speedIndex || '-'}</strong></span>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Load index"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <span className={styles.front}><T id="Front"/> <strong>{frontTyre.loadIndex || '-'}</strong></span>
                    <span><T id="Rear"/> <strong>{rearTyre.loadIndex || '-'}</strong> </span>

                    <OverlayTrigger
                      placement={isMobile() ? 'bottom' : 'right'}
                      overlay={<Tooltip id="loadindex-tooltip">
                          <div className={styles.loadIndexTooltip}>
                            <T id="The information is based on technical vehicle data and shows the most common original dimensions. The load index may vary depending on total weight, version, and equipment. Always check the vehicle registration certificate – that is the value that applies during installation." />
                          </div>
                        </Tooltip>}
                    >
                      <FontAwesomeIcon className={styles.carInfoIcon} icon={faInfoCircle} />
                    </OverlayTrigger>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Axle load"/> <T id="Front"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{front.maxLoad || '-'} kg</strong>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Axle load"/> <T id="Rear"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{rear.maxLoad || '-'} kg</strong>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Drive axles"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{vehicle.axles || '-'}</strong>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    TPMS
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>
                      {!!vehicle.hasTpms && (
                        <T id="Yes" />
                      )}
                      {!vehicle.hasTpms && (
                        <span>-</span>
                      )}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
          <Col xs={6}>
            <Table striped className={styles.carInfoTable}>
              <tbody>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Rim"/> <T id="Dimension"/> <T id="Front"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{frontRim.dimension || '-'}</strong>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Rim"/> <T id="Dimension"/> <T id="Rear"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{rearRim.dimension || '-'}</strong>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Et"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <span className={styles.front}><T id="Front"/> <strong>{etFront}</strong></span>
                    <span><T id="Rear"/> <strong>{etRear}</strong></span>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Bolt pattern"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{vehicle.rimBoltPattern || '-'}</strong>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Center bore"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{vehicle.rimCenterBore || '-'}</strong>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Bolt size & hex"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{vehicle.rimBoltSize || '-'}, {vehicle.rimBoltHex || '-'} mm</strong>
                  </td>
                </tr>
                <tr className={styles.infoLabel}>
                  <td>
                    <T id="Bolt torque"/>
                  </td>
                </tr>
                <tr className={styles.infoData}>
                  <td>
                    <strong>{vehicle.rimBoltTorque || '-'} Nm</strong>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    );
  }
}


const mapStateToProps = state => {
  const { vehicle } = state.vehicle.vehicle ? state.vehicle : state.carPicker
  const standard = (vehicle && vehicle.standard) || {}
  const frontRim = (standard && standard.front && standard.front.rim) || {}
  const rearRim = (standard && standard.rear && standard.rear.rim) || {}

  let etFront = frontRim.et || '-', etRear = rearRim.et || '-'
  if (frontRim.etMax && frontRim.etMin) {
    etFront = `${parseInt(frontRim.etMin, 10)}-${parseInt(frontRim.etMax, 10)}`
  }
  if (rearRim.etMax && rearRim.etMin) {
    etRear = `${parseInt(rearRim.etMin, 10)}-${parseInt(rearRim.etMax, 10)}`
  }

  return {
    vehicle,
    standard,
    frontRim,
    rearRim,
    etFront,
    etRear
  }
}

export default connect(mapStateToProps)(CarInfo);
